import './WriteEvent.scss'

import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import useConfirmation from '../../../hooks/ConfimationHook'
import Checkbox from '../../forms/Checkbox/Checkbox'
import Select from '../../forms/Select/Select'
import Input from '../../forms/Input/Input'
import Radio from '../../forms/Radio/Radio'
import DateTimePicker from '../../forms/DateTimePicker/DateTimePicker'
import Validators from '../../../forms/Validators'
import Tooltip from '../../core/Tooltip/Tooltip'
import unidecode from 'unidecode'
import { useModal } from '../../../contexts/Modal'
import { useEffect, useRef, useState } from 'react'
import { useToaster } from '../../../contexts/Toaster'
import { useCharacters } from '../../../contexts/Characters'
import { useData } from '../../../contexts/Data'
import { DateTime } from 'luxon'

const NewEvent = ({}) => {
    const modal = useModal()
    const toaster = useToaster()
    const characters = useCharacters()
    const data = useData()
    const { markOrExecute, isMarked, pendingItems } = useConfirmation()
    const scopeName = modal.$state.data.scope.name
    const { event } = modal.$state.data
    const [visibleCharacters, setVisibleCharacters] = useState([])
    const [selectedCharacters, setSelectedCharacters] = useState(event?.participantsType === 'custom' ? event.participants.map((character) => character._id) : [])
    const [filterKey, setFilterKey] = useState()
    const [syncDuration, setSyncDuration] = useState(event ? event.syncDuration : true)
    const formName = 'newEvent'
    const scopeCharacters = characters.$state[scopeName].accepted
    const eventTypeOptions = data.$state.eventTypes && data.$state.eventTypes[scopeName].map((type) => ({ value: type.name, label: type.label }))
    const participantsTypesOptions = [
        { value: 'all', label: `All ${scopeName} characters` },
        { value: 'custom', label: `Custom participants` }
    ]

    const writeEventRef = useRef()
    writeEventRef.current = () => {
        const formValues = form.$state.value
        formValues.participants = formValues.participantsType === 'custom' ? selectedCharacters : null
        formValues[scopeName] = event?.[scopeName] || characters.$state.current[scopeName]?._id
        formValues.syncDuration = syncDuration
        formValues.createPrimordialConflictWeek = formValues.createPrimordialConflictWeek && isWednesdayAtFour

        const saveEvent = event ? koalition.put(`events/${event._id}`, formValues) : koalition.post('events', formValues)
        saveEvent.then((response) => {
            modal.close()
            toaster.success('Event saved successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const form = useFormBuilder({ formName, onSubmit: () => writeEventRef.current(), controls: {
        type: { validators: [Validators.required], value: event?.type },
        startDate: { validators: [Validators.required], value: event?.startDate },
        endDate: { value: event?.endDate },
        notes: { value: event?.notes },
        participantsType: { value: event?.participantsType || 'all' },
        createElephants: { value: true },
        createMightiestEmpire: { value: true },
        createPrimordialConflictWeek: { value: true },
        enemyServer: {}
    } })

    const startDate = form.$state?.controls?.startDate?.value
    const startDateWeekday = startDate && DateTime.fromMillis(startDate, { zone: 'utc' }).weekday
    const startDateHour = startDate && DateTime.fromMillis(startDate, { zone: 'utc' }).hour
    const startDateMinute = startDate && DateTime.fromMillis(startDate, { zone: 'utc' }).minute
    const isWednesdayAtFour = startDateWeekday === 3 && startDateHour === 4 && startDateMinute === 0
    console.log(startDateWeekday, startDateHour, startDateMinute)

    const toggleParticipant = (character) => {
        setSelectedCharacters(selectedCharacters.includes(character._id) 
            ? selectedCharacters.filter((characterId) => characterId !== character._id)
            : [...selectedCharacters, character._id]
        )
    }

    const selectAll = () => setSelectedCharacters(scopeCharacters.map((character) => character._id))
    const deselectAll = () => setSelectedCharacters([])

    const deleteEvent = () => {
        koalition.delete(`events/${event?._id}`).then((response) => {
            toaster.success('Event deleted successfully')
            modal.close()
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const prefillEndDate = () => {
        const { startDate, type } = form.$state.value
        if (startDate && type && syncDuration) {
            const typeDuration = data.$state.eventTypes && data.$state.eventTypes[scopeName].find((eventType) => eventType.name === type)?.duration
            if (typeDuration) form.$state.controls.endDate.setValue(startDate + typeDuration)
        }
    }

    const prefillStartDate = () => {
        const { endDate, type } = form.$state.value
        if (endDate && type && syncDuration) {
            const typeDuration = data.$state.eventTypes && data.$state.eventTypes[scopeName].find((eventType) => eventType.name === type)?.duration
            if (typeDuration) form.$state.controls.startDate.setValue(endDate - typeDuration)
        }
    }

    useEffect(() => {
        setVisibleCharacters(scopeCharacters.filter((character) => {
            return !filterKey || character.name.toLowerCase().includes(filterKey.toLowerCase()) || unidecode(character.name.toLowerCase()).includes(filterKey.toLowerCase())
        }))
    }, [filterKey])

    useEffect(() => {
        if (syncDuration) prefillEndDate()
    }, [syncDuration])

    useEffect(() => {
        modal.configure({ formName, submitLabel: 'Save', size: 'lg' })
    }, [pendingItems])

    return (
        <div className="row justify-content-center write-event">
            <div className="col-12 mb-3">
                <Select control={form.$state.controls.type} options={eventTypeOptions} filterFrom={false} label="Event" onChange={prefillEndDate} />
            </div>

            <div className="col-lg-6 mb-3">
                <div className="row">
                    <div className="col">
                        <DateTimePicker control={form.$state.controls.startDate} label="Start" onChange={prefillEndDate} />
                    </div>
                    {form.$state.controls.type.value && data.$state.eventTypes && data.$state.eventTypes[scopeName].find((eventType) => eventType.name === form.$state.controls.type.value)?.duration && (
                        <div className="col-auto d-flex align-items-end pl-0 pl-lg-3">
                            <Tooltip text="Sync duration">
                                <button type="button" className={`medium icon ${syncDuration ? 'primary' : 'base darker'}`} onClick={() => setSyncDuration(!syncDuration)}>
                                    <img src="/images/icons/sync.svg" />
                                </button>
                            </Tooltip>
                        </div>
                    )}
                </div>
            </div>

            <div className="col-lg-6 mb-3">
                <DateTimePicker control={form.$state.controls.endDate} label="End" onChange={prefillStartDate} />
            </div>

            <div className="col-12 mb-3">
                <Input control={form.$state.controls.notes} label="Notes" />
            </div>

            <div className="col-12 mb-3 mt-4">
                <Radio control={form.$state.controls.participantsType} options={participantsTypesOptions} />
            </div>

            {form.$state.controls.participantsType.value === 'custom' && (
                <div className="col-12 mb-3">
                    <section className="card">
                        <div className="row align-items-center mb-4">
                            <h4 className="col-auto mb-3">Participants</h4>
                            <div className="col-auto mb-3">
                                <Input onChange={setFilterKey} placeholder="Filter" />
                            </div>
                            <div className="col-lg-auto ml-auto">
                                <button type="button" className="primary outline medium mr-2" onClick={deselectAll}>Deselect All</button>
                                <button type="button" className="primary medium" onClick={selectAll}>Select All</button>
                            </div>
                        </div>
                    
                        <ul className="participants">
                            {visibleCharacters.map((character) => (
                                <li className="d-inline-block mr-2 mb-2" key={character._id}>
                                    <span className={`chip participant ${selectedCharacters.includes(character._id) ? 'primary' : 'base'}`} onClick={() => toggleParticipant(character)}>{character.name}</span>
                                </li>
                            ))}
                        </ul>
                    </section>
                </div>
            )}

            {!event && form.$state.controls.type.value === 'goldenExpedition' && (
                <div className="col-12 mt-5 mb-3">
                    <Checkbox control={form.$state.controls.createElephants} label="Create Golden Elephant events" />
                </div>
            )}

            {!event && form.$state.controls.type.value === 'goldenExpedition' && form.$state.controls.createElephants.value && (
                <div className="col-12 mb-3">
                    <Input control={form.$state.controls.enemyServer} label="Enemy Server" />
                </div>
            )}

            {!event && form.$state.controls.type.value === 'mightiestEmpireImperialCityShowdown' && (
                <div className="col-12 mt-5 mb-3">
                    <Checkbox control={form.$state.controls.createMightiestEmpire} label="Create Mightiest Empire event" />
                </div>
            )}

            {!event && form.$state.controls.type.value === 'primordialConflict' && isWednesdayAtFour && (
                <div className="col-12 mt-5 mb-3">
                    <Checkbox control={form.$state.controls.createPrimordialConflictWeek} label="Create other cross border events" />
                </div>
            )}

            {event && (
                <div className="col-auto mr-auto my-4">
                    <button type="button" className={`danger outline ${isMarked(event._id) ? 'marked' : ''} medium`} onClick={() => markOrExecute(event._id, deleteEvent)}>
                        <span>Delete Event</span>
                    </button>
                </div>
            )}
        </div>
    )
}

export default NewEvent